import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';

import { meteringPointFields } from '../../constants/meteringPoint';
import { meteringPointType } from '../../constants/classificators';

const validatorRequiredForNotAvpAndAdmin = (value, form, props) =>
  !props.isAvp && props.isAdmin ? validatorRequired()(value) : undefined;

const validatorRequiredForConsumptionNotAvp = (value, form, props) =>
  props.pointType === meteringPointType.CONSUMPTION && !props.isAvp
    ? validatorRequired()(value)
    : undefined;

const validatorRequiredForConsumption = (value, form, props) =>
  props.pointType === meteringPointType.CONSUMPTION
    ? validatorRequired()(value)
    : undefined;

export default createValidation([
  {
    name: meteringPointFields.GAS,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: meteringPointFields.EICZ_CODE,
    validators: (value, form, props) =>
      validatorRequiredForNotAvpAndAdmin(value, form, props),
  },
  {
    name: meteringPointFields.COUNTY,
    validators: (value, form, props) =>
      validatorRequiredForNotAvpAndAdmin(value, form, props),
  },
  {
    name: meteringPointFields.CITY,
    validators: (value, form, props) =>
      validatorRequiredForNotAvpAndAdmin(value, form, props),
  },
  {
    name: meteringPointFields.ZIP_CODE,
    validators: (value, form, props) =>
      validatorRequiredForNotAvpAndAdmin(value, form, props),
  },
  {
    name: meteringPointFields.DISTRICT,
    validators: (value, form, props) =>
      validatorRequiredForNotAvpAndAdmin(value, form, props),
  },
  {
    name: meteringPointFields.START_DATE,
    validators: (value, form, props) =>
      validatorRequiredForConsumptionNotAvp(value, form, props),
  },
  {
    name: meteringPointFields.CONSUMPTION_TYPE,
    validators: (value, form, props) =>
      validatorRequiredForConsumption(value, form, props),
  },
  {
    name: meteringPointFields.DISSEMINATION_LEVEL,
    validators: (value, form, props) =>
      form.get(meteringPointFields.METERING_POINT_TYPE) ===
      meteringPointType.PRODUCTION
        ? validatorRequiredForNotAvpAndAdmin(value, form, props)
        : undefined,
  },
]);
